import styled from 'styled-components';

const StatusRow = styled.div`
  width: 100%;
  display: flex;
  justify-content: flex-end;
  padding-top: 4px;
`;

export default StatusRow;
